var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourBlocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 5.25,
    height: 5.25,
    rx: 1.5,
    fill: "#F8F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 5C9.75 4.17157 10.4216 3.5 11.25 3.5H13.5C14.3284 3.5 15 4.17157 15 5V7.25C15 8.07843 14.3284 8.75 13.5 8.75H11.25C10.4216 8.75 9.75 8.07843 9.75 7.25V5ZM3 11.75C3 10.9216 3.67157 10.25 4.5 10.25H6.75C7.57843 10.25 8.25 10.9216 8.25 11.75V14C8.25 14.8284 7.57843 15.5 6.75 15.5H4.5C3.67157 15.5 3 14.8284 3 14V11.75ZM11.25 10.25C10.4216 10.25 9.75 10.9216 9.75 11.75V14C9.75 14.8284 10.4216 15.5 11.25 15.5H13.5C14.3284 15.5 15 14.8284 15 14V11.75C15 10.9216 14.3284 10.25 13.5 10.25H11.25Z",
    fill: "#F8F5FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourBlocks);
export default __webpack_public_path__ + "static/media/four_blocks.e96f268795974d1da45d19660ab12694.svg";
export { ForwardRef as ReactComponent };